// extracted by mini-css-extract-plugin
module.exports = {"copyable":"style_copyable__VuUKr"};